<div class="top" *ngIf="!withEvent">
  <div class="checkbox">
    <input type="checkbox" [(ngModel)]="value" (change)="updateValue($any($event.target).checked)" [attr.disabled]="disabled ? '' : null">
  </div>
  <div class="label">
    <label [ngStyle]="{ color: (disabled ? '#888' : null) }">
      {{label}}
    </label>
  </div>
</div>

<ng-container *ngIf="withEvent">
  <input type="checkbox" [(ngModel)]="value" (mousedown)="mousedown($event)" (change)="handleEvent($event)" [attr.disabled]="disabled ? '' : null">
</ng-container>